import { render, staticRenderFns } from "./ExpedientePersonalPage.vue?vue&type=template&id=9c442272"
import script from "./ExpedientePersonalPage.vue?vue&type=script&lang=js"
export * from "./ExpedientePersonalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports